var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobiledeScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#552883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#350051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#240044"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.22321,36.78668c-2.41577,0-4.28064,1.3476-5.26874,3.84351l-5.50452,13.5874v-12.08179c0-2.93091-1.70227-5.34912-4.87317-5.34912-2.61481,0-4.23914,1.50537-5.1911,3.84351l-5.62555,13.82526v-17.23163h-5.90497v25.55267h8.04169l7.80621-18.42389v13.86652c0,2.89185,1.58301,4.9942,4.47723,4.9942,2.49591,0,3.84351-1.42767,4.75397-3.60321l6.37848-15.37189v18.54034h5.90466v-20.64276c0-2.93091-1.78204-5.34912-4.9942-5.34912Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.30518,62.77832v-25.55261h-10.93585v-.00452c-3.09082,0-5.58673,2.49829-5.58673,5.58667v14.38348c0,3.09082,2.49829,5.58698,5.58673,5.58698h10.93585Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiledeScraper);
export default __webpack_public_path__ + "static/media/mobilede-scraper.13fbbe3f5005a32830a487f8bd5e8997.svg";
export { ForwardRef as ReactComponent };